import { render, staticRenderFns } from "./IllegalAdResultModal.vue?vue&type=template&id=c17130d0&scoped=true&"
import script from "./IllegalAdResultModal.vue?vue&type=script&lang=js&"
export * from "./IllegalAdResultModal.vue?vue&type=script&lang=js&"
import style0 from "./IllegalAdResultModal.vue?vue&type=style&index=0&id=c17130d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17130d0",
  null
  
)

export default component.exports